import Model from '~/models/base/Model';

/**
 * class representing Automatic Action
 * @extends Model
 */
export default class AutomaticAction extends Model {
    static _url = `${APP_URL.automation}/automatic-actions`;

    static getByType(type) {
        const requestUrl = `${this._url}/${type}/`;
        return this.api.get(requestUrl);
    }

    static getFields(actionInternalName, triageId = '', resultId = '') {
        const requestUrl = `${this._url}/${actionInternalName}/fields/`;
        // may be revised:
        const params = {};
        if (triageId || resultId) {
            if (!triageId) {
                params.triage_id = triageId;
            }
            if (!resultId) {
                params.triage_id = triageId;
            } else {
                params.triage_id = triageId;
                params.result_id = resultId;
            }
        }
        const requestPayload = { params: params };
        return this.api.get(requestUrl, requestPayload);
    }

    static getPlaceholderList(
        incidentId,
        taskFields = false,
        noteFields = false,
        attachmentFields = false
    ) {
        const requestUrl = `${APP_URL.automation}/getPlaceholderList/`;
        const requestPayload = {
            params: {
                incident_id: incidentId,
                task_fields: taskFields,
                note_fields: noteFields,
                attachment_fields: attachmentFields
            }
        };
        return this.api.get(requestUrl, requestPayload);
    }

    static editOutputTableViewFields(params = {}) {
        return this.api.post(`${this._url}/update-output-table-view/`, params);
    }
}
